/* eslint-disable */
export default {
    original_sale: {
        columns: {
            channelTime: {
                label: "销售日期",
                name: "channelTime",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "销售日期",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            ddiSellerCode: {
                label: "DDI客户编码",
                name: "ddiSellerCode",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "DDI客户编码",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            ddiSellerName: {
                label: "DDI客户名称",
                name: "ddiSellerName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "DDI客户名称",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            companyName: {
                label: "卖方客户名称",
                name: "companyName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "卖方客户名称",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            provinceName: {
                label: "DDI客户省份",
                name: "provinceName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "DDI客户省份",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            buyerName: {
                label: "买方客户名称",
                name: "buyerName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "买方客户名称",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            customerCode: {
                label: "客户编码",
                name: "customerCode",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "客户编码",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            productCode: {
                label: "产品编码",
                name: "productCode",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "产品编码",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            productName: {
                label: "产品名称",
                name: "productName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "产品名称",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            spec: {
                label: "规格",
                name: "spec",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "规格",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            count: {
                label: "数量",
                name: "count",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数量",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            price: {
                label: "单价",
                name: "price",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数量",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            totalPrice: {
                label: "金额",
                name: "totalPrice",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数量",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            productUnit: {
                label: "单位",
                name: "productUnit",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "单位",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            batchNumber: {
                label: "批号",
                name: "batchNumber",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "批号",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            manufacturer: {
                label: "生产厂家",
                name: "manufacturer",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "生产厂家",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            uploadDataTime: {
                label: "数据上传时间",
                name: "uploadDataTime",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数据上传时间",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
        },
        filters: {
            beginTime: {
                label: "开始时间",
                name: "beginTime",
                columnName: "beginTime",
                type: "Date",
                matchType: "Between",
                isSearch: null,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 70,
            },
            endTime: {
                label: "结束时间",
                name: "endTime",
                columnName: "endTime",
                type: "Date",
                matchType: "Between",
                isSearch: null,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 70,
            },
            customerProvince: {
                label: "DDI客户省份",
                name: "customerProvince",
                columnName: "customerProvince",
                type: "Select",
                matchType: "Contains",
                isSearch: null,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 120,
            },
            agencyKeys: {
                label: "DDI客户名称",
                name: "agencyKeys",
                columnName: "agencyKeys",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 121,
            },
            companyNames: {
                label: "卖方客户名称",
                name: "companyNames",
                columnName: "companyNames",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 122,
            },
            products: {
                label: "产品规格",
                name: "products",
                columnName: "products",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 123,
            },
            customs: {
                label: "买方客户名称",
                name: "customs",
                columnName: "customs",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 124,
            },
        },
    },
    original_purchase: {
        columns: {
            purchaseTime: {
                label: "采购日期",
                name: "purchaseTime",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "采购日期",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            ddiBuyerCode: {
                label: "DDI客户编码",
                name: "ddiBuyerCode",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "DDI客户编码",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            ddiBuyerName: {
                label: "DDI客户名称",
                name: "ddiBuyerName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "DDI客户名称",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            companyName: {
                label: "采购商名称",
                name: "companyName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "采购商名称",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            buyerProvince: {
                label: "DDI客户省份",
                name: "buyerProvince",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "DDI客户省份",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            sellerName: {
                label: "供应商名称",
                name: "sellerName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "供应商名称",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            sellerCode: {
                label: "供应商编码",
                name: "sellerCode",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "供应商编码",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            sellerProvince: {
                label: "供应商省份",
                name: "sellerProvince",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "供应商省份",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            productCode: {
                label: "产品编码",
                name: "productCode",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "产品编码",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            productName: {
                label: "产品名称",
                name: "productName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "产品名称",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            spec: {
                label: "规格",
                name: "spec",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "规格",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            count: {
                label: "数量",
                name: "count",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数量",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            price: {
                label: "单价",
                name: "price",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数量",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            totalPrice: {
                label: "金额",
                name: "totalPrice",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数量",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            productUnit: {
                label: "单位",
                name: "productUnit",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "单位",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            batchNumber: {
                label: "批号",
                name: "batchNumber",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "批号",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            manufacturer: {
                label: "生产厂家",
                name: "manufacturer",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "生产厂家",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            uploadDataTime: {
                label: "数据上传时间",
                name: "uploadDataTime",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数据上传时间",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
        },
        filters: {
            // dataFlowType: {
            //     label: "流向类型",
            //     name: "dataFlowType",
            //     columnName: "dataFlowType",
            //     type: "Select",
            //     matchType: "In",
            //     isSearch: null,
            //     isRequired: false,
            //     isEditable: true,
            //     isHidden: null,
            //     isTag: false,
            //     optionSource: null,
            //     options: [
            //         {
            //             label: "销售",
            //             code: "sales",
            //         },
            //         {
            //             label: "采购",
            //             code: "purchase",
            //         },
            //         {
            //             label: "库存",
            //             code: "inventory",
            //         },
            //     ],
            //     index: 70,
            // },
            beginTime: {
                label: "开始时间",
                name: "beginTime",
                columnName: "beginTime",
                type: "Date",
                matchType: "Between",
                isSearch: null,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 70,
            },
            endTime: {
                label: "结束时间",
                name: "endTime",
                columnName: "endTime",
                type: "Date",
                matchType: "Between",
                isSearch: null,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 70,
            },
            customerProvince: {
                label: "DDI客户省份",
                name: "customerProvince",
                columnName: "customerProvince",
                type: "Select",
                matchType: "Contains",
                isSearch: null,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 120,
            },
            agencyKeys: {
                label: "DDI客户名称",
                name: "agencyKeys",
                columnName: "agencyKeys",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 121,
            },
            companyNames: {
                label: "采购商名称",
                name: "companyNames",
                columnName: "companyNames",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 122,
            },
            products: {
                label: "产品规格",
                name: "products",
                columnName: "products",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 123,
            },
            suppliers: {
                label: "供应商名称",
                name: "suppliers",
                columnName: "suppliers",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 124,
            },
        },
    },
    original_inventory: {
        columns: {
            inventoryTime: {
                label: "库存日期",
                name: "inventoryTime",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "采购日期",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            ddiCustomerCode: {
                label: "DDI客户编码",
                name: "ddiCustomerCode",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "DDI客户编码",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            ddiCustomerName: {
                label: "DDI客户名称",
                name: "ddiCustomerName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "DDI客户名称",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            companyName: {
                label: "库存客户名称",
                name: "companyName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "库存客户名称",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            provinceName: {
                label: "DDI客户省份",
                name: "provinceName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "DDI客户省份",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            productCode: {
                label: "产品编码",
                name: "productCode",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "产品编码",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            productName: {
                label: "产品名称",
                name: "productName",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "产品名称",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            spec: {
                label: "规格",
                name: "spec",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "规格",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            count: {
                label: "数量",
                name: "count",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数量",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            price: {
                label: "单价",
                name: "price",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数量",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            totalPrice: {
                label: "金额",
                name: "totalPrice",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数量",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            productUnit: {
                label: "单位",
                name: "productUnit",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "单位",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            batchNumber: {
                label: "批号",
                name: "batchNumber",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "批号",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            manufacturer: {
                label: "生产厂家",
                name: "manufacturer",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "生产厂家",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
            uploadDataTime: {
                label: "数据上传时间",
                name: "uploadDataTime",
                type: "Input",
                isRequired: null,
                isEditable: null,
                isHidden: null,
                isTag: null,
                isSearch: null,
                isPush: false,
                visible: true,
                disabled: null,
                group: null,
                comment: "数据上传时间",
                defValue: null,
                optionSource: null,
                options: null,
                index: 522,
                format: null,
                exportFormat: null,
                style: {
                    id: 3,
                    tenantId: null,
                    width: "150",
                    minWidth: null,
                    widthScale: null,
                },
            },
        },
        filters: {
            dataFlowType: {
                label: "流向类型",
                name: "dataFlowType",
                columnName: "dataFlowType",
                type: "Select",
                matchType: "In",
                isSearch: null,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: [
                    {
                        label: "销售",
                        code: "sales",
                    },
                    {
                        label: "采购",
                        code: "purchase",
                    },
                    {
                        label: "库存",
                        code: "inventory",
                    },
                ],
                index: 70,
            },
            beginTime: {
                label: "开始时间",
                name: "beginTime",
                columnName: "beginTime",
                type: "Date",
                matchType: "Between",
                isSearch: null,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 70,
            },
            endTime: {
                label: "结束时间",
                name: "endTime",
                columnName: "endTime",
                type: "Date",
                matchType: "Between",
                isSearch: null,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 70,
            },
            customerProvince: {
                label: "DDI客户省份",
                name: "customerProvince",
                columnName: "customerProvince",
                type: "Select",
                matchType: "Contains",
                isSearch: null,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: {
                    path: "/v1/look-permission/areatree",
                    id: "optionId",
                    valueField: "type",
                },
                options: null,
                index: 120,
            },
            agencyKeys: {
                label: "DDI客户名称",
                name: "agencyKeys",
                columnName: "agencyKeys",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: {
                    path: "/v1/look-permission/areatree",
                    id: "optionId",
                    valueField: "type",
                },
                options: null,
                index: 121,
            },
            companyNames: {
                label: "卖方客户名称",
                name: "companyNames",
                columnName: "companyNames",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 122,
            },
            products: {
                label: "产品名称",
                name: "products",
                columnName: "products",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 123,
            },
            customs: {
                label: "买方客户名称",
                name: "customs",
                columnName: "customs",
                type: "Select",
                matchType: "In",
                isSearch: true,
                isRequired: false,
                isEditable: true,
                isHidden: null,
                isTag: false,
                optionSource: null,
                options: null,
                index: 124,
            },
        },
    },
};
